import { typedPageSelectors, usePage } from 'publisher/store'
import React from 'react'
import { BasePublisherButton } from 'src/publisher/entities/base-publisher-button'
import { RegistrationButtonInterface } from 'src/shared/types/entities/registration-button-interface'

const TEST_ID = 'registration-button'

export interface RegistrationButtonProps {
  entity: RegistrationButtonInterface
}

export const RegistrationButton = ({ entity }: RegistrationButtonProps) => {
  const locale = usePage(state => typedPageSelectors.getLocale(state))

  return (
    <BasePublisherButton
      entity={entity}
      onClick={() => {
        location.assign(`/${locale}/register`)
      }}
      testId={TEST_ID}
    />
  )
}
